import { uploadFile as apiUploadFile, initChunk, complete } from '@/api/upload/api'
import { uploadFile as chunkUploadFile } from '@/utils/chunkUpload'


/**
 * 主文件上传入口，自动判断是单文件还是大文件分片上传
 */
export function doFileUpload(file, options = {}) {
  const maxSingleFileSize = 5 * 1024 * 1024 
  if (file.size <= maxSingleFileSize) {
    // 单文件上传
    return uploadSingleFileHelper(file, options)
  } else {
    // 大文件分片上传
    return uploadChunkFileHelper(file, options)
  }
}

async function uploadSingleFileHelper(file, options) {
  let fileBindId = options.fileBindId;
  const resolvedFileType = options.fileType || file.fileType
  try {
    if (typeof options.onProgress === 'function') options.onProgress(30)
    const formData = new FormData()
    formData.append('file', file)
    formData.append('fileType', resolvedFileType)
    formData.append('fileName', file.name)
    formData.append('fileSize', file.size)
    formData.append('fileBindId', fileBindId)
    if (options.secretKey) {
      formData.append('secretKey', options.secretKey)
    }
    
    if (typeof options.onProgress === 'function') options.onProgress(60)
    const uploadResult = await apiUploadFile(formData)
    if (uploadResult.code !== 0 && uploadResult.code !== 200) {
      throw new Error(uploadResult.message || '上传失败')
    }
    if (typeof options.onProgress === 'function') options.onProgress(100)
    const data = uploadResult.data || uploadResult;
    const result = {
      success: true,
      fileGuid: data.fileGuid,
      uploadFileId: data.uploadFileId,
      filePath: data.filePath,
      registrationGuid: data.registrationGuid,
      fileId: data.fileId || ''
    }
    if (typeof options.onSuccess === 'function') options.onSuccess(result)
    return result
  } catch (error) {
    const fail = { success: false, message: error.message || '上传失败' }
    if (typeof options.onError === ' 大文件分片上传') options.onError(fail)
    return fail
  }
}
// 大文件分片上传
function uploadChunkFileHelper(file, options) {
  const fileBindId = options.fileBindId;
  // 透传 fileType / secretKey 到分片上传链路（兼容 file.fileType 旧用法）
  if (options.fileType && !file.fileType) {
    try { file.fileType = options.fileType } catch (e) { /* read-only fallback */ }
  }
  return new Promise((resolve, reject) => {
    chunkUploadFile(file, {
      ...options,
      fileBindId,
      fileType: options.fileType || file.fileType,
      secretKey: options.secretKey,
      onProgress: (percentage) => {
        if (typeof options.onProgress === 'function') options.onProgress(percentage)
      },
      onSuccess: (result) => {
        const out = {
          success: true,
          fileGuid: result.data?.fileGuid || '',
          filePath: result.fileUrl || result.data?.filePath || '',
          uploadFileId: result.fileId || result.data?.uploadFileId || '',
          registrationGuid: result.data?.registrationGuid || '',
          fileId: result.data?.fileId || result.fileId || result.initResult?.fileId || ''
        }
        if (typeof options.onSuccess === 'function') options.onSuccess(out)
        resolve(out)
      },
      onError: (error) => {
        const fail = { success: false, message: error.message || '上传失败' }
        if (typeof options.onError === 'function') options.onError(fail)
        reject(fail)
      }
    })
  })
}

export { pauseUpload, resumeUpload, cancelUpload, getUploadProgress, getAllUploadTasks, clearAllTasks } from '@/utils/chunkUpload';
